/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-05-03
 */

import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {reducer as userReducer} from './users/users.state';
import {reducer as dirtyReducer} from './dirty.state';
import {reducer as syllabusReducer} from './syllabus/syllabus.state';
import {reducer as errorReducer} from './error.state';
import {reducer as sessionReducer} from './session.state';

const getReducer = () => combineReducers({
	syllabus: syllabusReducer,
	users: userReducer,
	router: routerReducer,
	dirty: dirtyReducer,
	error: errorReducer,
	session: sessionReducer,
	lastAction: (state, action) => action
});

export default getReducer;


// WEBPACK FOOTER //
// ./src/reducer.js